import { pathOr } from 'ramda';

import { IState } from '../../store';

export const getNewbuildingStatus = (state: IState) => {
  return pathOr('-', ['offerData', 'newObject', 'status'], state);
};
